import Vue from 'vue'
import store from './store/index'
import './element'
import 'default-passive-events'
// import App from '/src/App';
import LYCom from '../static/js/LYCom'
import 'font-awesome/css/font-awesome.min.css'
import './api/permission'

import request from "./network/request"

// 视频插件
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video

// 打印插件
import Print from 'vue-print-nb'
Vue.use(Print);

import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

Vue.config.productionTip = false
window.LYCom = LYCom; // 公共类


Vue.prototype.$bus = new Vue();
Vue.prototype.$LYCom = LYCom;
Vue.prototype.$request = request;
import App from './App'
import router from './router'
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js